module.exports = __webpack_public_path__ + "img/Logo_Prof_2024.614c17d3.svg";